import { i18n } from '../i18n'

let loaderPromise = null

// Google Maps JavaScript API 스크립트를 1회만 동적 로드한다.
export function loadGoogleMaps () {
  if (window.google && window.google.maps) return Promise.resolve(window.google.maps)
  if (loaderPromise) return loaderPromise
  loaderPromise = new Promise((resolve, reject) => {
    const callbackName = '__googleMapsApiOnLoad'
    window[callbackName] = function () {
      delete window[callbackName]
      resolve(window.google.maps)
    }
    const script = document.createElement('script')
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + process.env.GOOGLE_MAP_KEY +
      '&language=' + i18n.locale + '&callback=' + callbackName
    script.async = true
    script.onerror = function (error) {
      loaderPromise = null
      reject(error)
    }
    document.head.appendChild(script)
  })
  return loaderPromise
}



// WEBPACK FOOTER //
// ./src/util/googleMapsLoader.js